export default __webpack_public_path__ + "static/media/img-0296-zambia-premium-face.0dfcb3e3.png";